module.exports = __webpack_public_path__ + "img/datastart.fd14b140.png";